import React from 'react';
export var FinectLogo = function FinectLogo(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 100",
    width: size || '100',
    fill: color || '#3c44d7',
    style: {
      height: 'auto'
    }
  }, React.createElement("path", {
    d: "M71.74 68.77V35.24H92.6v5.34H77.42V50H91v5.25H77.42v13.52h-5.68zM111.24 68.77V35.24H117v33.53h-5.76z"
  }), React.createElement("path", {
    opacity: ".7",
    d: "M157.87 68.77l-16.55-25.4v25.4h-5.67V35.24h7.24L158.11 59V35.24h5.67v33.53h-5.91z"
  }), React.createElement("path", {
    d: "M163.78 68.77h-5.91l-16.55-25.4v25.4h-5.67V35.24h7.24L158.11 59zM182.42 68.77V35.24h20.71v5.3h-15v8.89h13.62v5.16H188.1v8.89h15v5.3h-20.68zM221.77 52c0-10.92 8.18-17.5 16.88-17.5 8.51 0 13.57 5 15.09 10.88l-5.34 1.8c-1-4.07-4.11-7.33-9.74-7.33s-11.07 4-11.07 12.15c0 7.85 5.39 12 11.11 12a10 10 0 0 0 10-7.38l5.2 1.7c-1.51 5.67-6.62 11.11-15.18 11.11-9.05.04-16.95-6.43-16.95-17.43zM289.08 40.58v28.19h-5.68V40.58h-10.88v-5.34H300v5.34h-10.92z"
  }), React.createElement("circle", {
    cx: "38.86",
    cy: "51.77",
    r: "4.66"
  }), React.createElement("path", {
    opacity: ".7",
    d: "M2.91 69.47A2.91 2.91 0 0 1 0 66.56V37.44a2.91 2.91 0 0 1 .85-2.06L30 6.26a2.91 2.91 0 0 1 5 2.06v29.12a2.91 2.91 0 0 1-.85 2.06L5 68.62a2.91 2.91 0 0 1-2.09.85zm2.91-30.82v20.88l23.3-23.3V15.35z"
  }), React.createElement("path", {
    d: "M32 98.6a2.91 2.91 0 0 1-2-.86L.85 68.62A2.91 2.91 0 0 1 0 66.56V37.44a2.91 2.91 0 0 1 5-2.06L34.09 64.5a2.91 2.91 0 0 1 .85 2.06v29.12A2.91 2.91 0 0 1 32 98.6zM5.82 65.36l23.3 23.3V67.77l-23.3-23.3v20.89z"
  }));
};